import React, { Component } from "react";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import Icon from "../UI/Icon/Icon";

var classNames = require("classnames");

class QualificationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };
  }

  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg2 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      }
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });

    let bigram = this.props.subtitleText.split(' ').map(letter => letter[0]).slice(0, 2).join('').toUpperCase()
    let favourites = (this.props.favourites)
    let qualifications =
      favourites
        .filter(f => this.props.qualifications.map(q => q.key).includes(f.key))
        .concat(this.props.qualifications
          .filter(qual => !favourites.map(f => f.key).includes(qual.key)))
    const favouriteIcon = <Icon
      icon="icon_favouriteQual"
    />

    return (
      <div>
        <div className={CloseAlertControls}>
          <div className={styles.content}>
            <div className={styles.spanButtons + " " + styles.noPadding}>
              <span>{this.props.titleText}</span>
              <button
                className="closeAlertControls__btn -close"
                onClick={this.props.onClose}
              >
              </button>
            </div>
            <div className={styles.section + " " + styles.horizontalLayout + " " + styles.qualifcationList}>
              <span className={styles.subtitleText + " " + styles.userNameLayout}>
                <span className={styles.bigram}>{bigram}</span>
                {`${this.props?.subtitleText} (${this.props?.qualifications?.length})`}
              </span>
            </div>
            <ul className={styles.listContainer}>
              {qualifications.map(qual => {
                return (
                  <div key={qual?.key} className={styles.listItem + " " + styles.qualificationList}>
                    <li key={qual?.key}>
                      {qual?.value}
                    </li>
                    {favourites.map(f => f.key).includes(qual?.key) && favouriteIcon}
                  </div>

                )
              })}
            </ul>
            <div className={styles.spanButtons + " " + styles.bottom}>
              {this.props.buttons}
            </div>
          </div>
        </div>
        <div className={DarkMask} onClick={this.props.onClose} />
      </div>
    );
  }
}

export default withRouter(QualificationsList);
